import { render } from "./Register.vue?vue&type=template&id=36d13c63&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__